import { Component, OnInit, Inject } from '@angular/core';
import { StepComponent } from '@icc/configurator/shared';
import { ShutterFacade } from '../+state/shutter.facade';
import { ColorsService } from '../colors.service';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared';
import { _ } from "@icc/shared/helpers";

@Component({
    selector: 'icc-colors',
    templateUrl: './colors.component.html',
    styleUrls: ['./colors.component.scss'],
    standalone: false
})
export class ColorsComponent extends StepComponent implements OnInit {
    static stepName = _('ROLLER_SHUTTER_LEGACY|Kolor');
    static stepIcon = {
        ligature: 'palette',
    };

    public configurator = 'roller_shutter';
    public stepId = 'rollercolor';
    public title = _('ROLLER_SHUTTER_LEGACY|Wybierz kolor:');

    colors$ = {
      boxInner: this.shutterFacade.boxInnerColor$,
      boxGuideOuter: this.shutterFacade.boxGuideOuterColor$,
      box: this.shutterFacade.boxColor$,
      guideRail: this.shutterFacade.guideRailColor$,
      profile: this.shutterFacade.profileColor$,
      endslat: this.shutterFacade.endslatColor$,
      revision: this.shutterFacade.revisionColor$,
      boxSideSurface: this.shutterFacade.boxSideSurfaceColor$,
    };

    colorsShow$ = {
      boxInner: this.shutterFacade.boxInnerColorShow$,
      boxGuideOuter: this.shutterFacade.boxGuideOuterColorShow$,
      box: this.shutterFacade.boxColorShow$,
      guideRail: this.shutterFacade.guideRailColorShow$,
      profile: this.shutterFacade.profileColorShow$,
      endslat: this.shutterFacade.endslatColorShow$,
      revision: this.shutterFacade.revisionColorShow$,
      boxSideSurface: this.shutterFacade.boxSideSurfaceColorShow$,
    };

    colorsTitle = {
      boxInner: _('ROLLER_SHUTTER_LEGACY|Kolor skrzynki wewnątrz:'),
      boxGuideOuter: this.config().IccConfig.Configurators.roller_shutter.boxColorGuideColor ? _( 'ROLLER_SHUTTER_LEGACY|Kolor skrzynki od zewnątrz:') : _('ROLLER_SHUTTER_LEGACY|Kolor skrzynki od zewnątrz i prowadnic:'),
      box: _('ROLLER_SHUTTER_LEGACY|Kolor skrzynki:'),
      guideRail: _('ROLLER_SHUTTER_LEGACY|Kolor prowadnic:'),
      profile: _('ROLLER_SHUTTER_LEGACY|Kolor pancerza:'),
      endslat: _('ROLLER_SHUTTER_LEGACY|Kolor listwy końcowej:'),
      revision: _('ROLLER_SHUTTER_LEGACY|Kolor klapy rewizyjnej:'),
      boxSideSurface: _('ROLLER_SHUTTER_LEGACY|Kolor boczków skrzynki:'),
    };

    constructor(
      @Inject(APP_CONFIG) private config: AppConfigFactory,
      private shutterFacade: ShutterFacade,
      private colorsService: ColorsService,
    ) {
        super();
    }

    ngOnInit() {}

    openModalRollerColor(
        type:
            | 'boxInner'
            | 'boxGuideOuter'
            | 'box'
            | 'guideRail'
            | 'profile'
            | 'endslat'
            | 'revision'
            | 'boxSideSurface'
    ) {
        const triggerElement = document.activeElement as HTMLElement;
        const pageContainer = document.getElementById('page-container');
        const scrollTop = pageContainer?.scrollTop || 0;
        const stepName = this.colorsTitle[type];
        this.colorsService.openModalRollerColor(type, stepName).closed.then(() => {
            if (pageContainer) {
                pageContainer.scrollTop = scrollTop;
            }
            requestAnimationFrame(() => {
                if (pageContainer) {
                    pageContainer.scrollTop = scrollTop;
                }
                triggerElement?.focus({ preventScroll: true });
            });
        });
    }
}
